import script from "./NimbusLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./NimbusLoader.vue?vue&type=script&setup=true&lang=js"

import "./NimbusLoader.vue?vue&type=style&index=0&id=68eed1f8&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68eed1f8"]])

export default __exports__